import TestPackageFirstSection from "../PageElements/TestPackagesElements/TestPackageFirstSection";
import {OurPackageMainSection} from "../PageElements/OurPackagesPageElements/OurPackageMainSection";
import TestPackageMainSection from "../PageElements/TestPackagesElements/TestPackageMainSection";
import ServiceSection from "../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../PageElements/HomePageElements/ConsultSection";

export default function TestPackagesPage() {
    return (
        <>
            <TestPackageFirstSection/>
            <TestPackageMainSection/>
            {/* <ServiceSection /> */}
            <ConsultSection />
        </>
    )
}